export default {
	countryCode: "Indicatif du pays",
};
